class AdminRolesFormValidation {
    constructor(formID) {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');

        this.managerFormValidation(formID);
        this.changeRoleSelect(formID);
        this.initIdentitySelect();
    }
    initTagifyInviteManagers(response){
        const thisClass = this;
        const emailInput = document.querySelector('#frm-inviteManagerForm-inviteManagerForm input[name=UsernameInvite]');
        const identityInput = document.querySelector('#frm-inviteManagerForm-inviteManagerForm input[name=identities]');
        if(emailInput){
            let tg = new Tagify(emailInput, {
                transformTag: function(tagData) {
                    tagData.value = tagData.value.toLowerCase();
                    return;
                },
                pattern: /^(?:(?!.{101,})[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/,
                keepInvalidTags: false,
                editTags: 1,
                blacklist: response.managerArr,
                delimiters: ",|;| ,| |:|[\\\r]",
                maxTags: 10,
            });
            new SpacebarEvent(tg);
        }
        if(identityInput){
            let tagify = new IdentityTagify(identityInput, response.identityArr);
            let names = [];
            names[0] = 'GoodAccess';
            tagify.addTags(names);
            var tags = tagify.DOM.scope.querySelectorAll('.tagify__tag');
            tags.forEach(function(tag) {
                var removeBtn = tag.querySelector('.tagify__tag__removeBtn');
                if (tagify.value.length < 2) {
                    removeBtn.style.display = 'none';
                } else {
                    removeBtn.style.display = '';
                }
            });
        }
    }

    initIdentitySelect(){
        var optionFormat = function(item) {
            if ( !item.id ) {
                return item.text;
            }

            var span = document.createElement('span');
            var imgUrl = item.element.getAttribute('data-kt-select2-identity');
            var template = '';

            template += '<img src="' + imgUrl + '" class="rounded-circle h-20px me-2" alt="image"/>';
            template += item.text;

            span.innerHTML = template;

            return $(span);
        }
        $('#frm-inviteManagerForm-inviteManagerForm select[name=identity]').select2({
            templateSelection: optionFormat,
            templateResult: optionFormat,
            //turn off search
            minimumResultsForSearch: -1,
        });
    }

    changeRoleSelect(formID){
        $('#'+formID+' select[name=roleID]').on('select2:select', function (e) {
            const description = e.params.data.element.attributes.description.value;
            $('#'+formID+' .role-description').text(description);
        });
    }
    async getAllAdmins(){
        return await fetch('/admin-roles/?do=getAllAdmins&organizationID=' + this.organizationID)
            .then(response => {
                if (!response.ok) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }
    managerFormValidation(formID){
        let form = document.getElementById(formID);
        if(form){
            if(form.querySelector('input[name=UsernameInvite]')){
                this.getAllAdmins().then(response => {
                    this.initTagifyInviteManagers(response);
                });
            }

            let formContainer = $(form);

            let submitButtonID = formContainer.find('button[type=submit]')[0].attributes.id.value;
            let submitButton = document.getElementById(submitButtonID);

            FormValidation.formValidation(
                form,
                {
                    fields: {
                        'UsernameInvite': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                        'roleID': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                        'identities': {
                            validators: {
                                notEmpty: {
                                    message: 'At least one identity is required'
                                },
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                    }
                }
            ).on('core.form.validating', function(event) {
                new DismissModal(formContainer.find('.modal')[0].attributes.id.value).disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                new DismissModal(formContainer.find('.modal')[0].attributes.id.value).enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }
}
window.AdminRolesFormValidation = AdminRolesFormValidation;